import React, { useEffect, useState } from "react";
import "./Cart.css";
import { Link, useLocation } from "react-router-dom";
import commonImg from "assets/images/brown.png";
import {
  Col,
  Collapse,
  Form,
  OverlayTrigger,
  Popover,
  Row,
} from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import "react-calendar/dist/Calendar.css";
import Button from "react-bootstrap/Button";
import { useForm } from "react-hook-form";
import CartSection from "components/CartSection/CartSection";
import { useDispatch, useSelector } from "react-redux";
import { cartActions } from "rtk/slices/CartSlice";
import axios from "axios";
import MyVerticallyCenteredModal from "./CalenderModal/MyVerticallyCenteredModal";
import { toast } from "react-toastify";
import Helmet from "ui/helmet/Helmet";
import ModalNote from "ui/modalNote/ModalNote";
import knetIcon from "assets/images/knet-icon.svg";
import "react-phone-input-2/lib/style.css";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { LanguageContext } from "context/LanguageContext";
import iconPhone from "assets/images/kuwait.png";

const Cart = () => {
  const [modalShowNote, setModalShowNote] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [selecteddate, setselecteddate] = useState(new Date());
  const [dateFormated, setDateFormated] = useState(formatDate(selecteddate));
  const [selectedTimeStart, setSelectedTimeStart] = useState();
  const [selectedTimeEnd, setSelectedTimeEnd] = useState();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [dataTime, setDataTime] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState();
  const [areas, setAreas] = useState([]);
  const [tab, setTab] = useState("house");
  const [txtNote, setTxtNote] = useState();
  const [country, setCoutry] = useState();
  const [area, setArea] = useState();
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [valueNow, setValueNow] = useState("12:00:AM");
  const [selecNowActive, setselecNowActive] = useState(false);
  const [changedLabel, setChangedLabel] = useState(false);
  const { selectedAreas, setSelectedAreas } = useContext(LanguageContext);
  const productsInState = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const { lang, setLang, changeLanguage } = useContext(LanguageContext);
  const location = useLocation();
  const whatsappNumber = "96565557780";
  const appointment_id = 1;
  let backLink = "/";

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();

  const handleclosemodalNote = () => {
    setModalShowNote(false);
  };

  const handlePhoneChange = (value) => {
    setPhoneNumber(value);
  };
  const handleclosemodal = () => {
    setModalShow(false);
  };

  function formatDate(date) {
    const year = date && date.getFullYear();
    const month = date && date.getMonth() + 1; // Month is zero-based, so we add 1
    const day = date && date.getDate();

    // Pad single-digit month and day with leading zeros if needed
    const formattedMonth = month < 10 ? `0${month}` : month;
    const formattedDay = day < 10 ? `0${day}` : day;

    return `${year}-${formattedMonth}-${formattedDay}`;
  }
  const handledatechange = (date) => {
    const currentDate = new Date();
    if (date.getDate() < currentDate.getDate()) {
      return;
    }
    setselecteddate(date);
    const formattedDate = formatDate(date);
    setDateFormated(formattedDate);
  };

  const getTime = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}api/available-appointments?date=${dateFormated}`
      )
      .then((data) => {
        setDataTime(data.data);
      });
  };

  const getCountries = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}api/country`)
      .then((response) => {
        setCountries(response.data);
      });
  };

  const getAreas = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}api/country/${selectedCountry}`)
      .then((data) => {
        setAreas(data.data);
      });
  };

  useEffect(() => {
    selectedCountry && getAreas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry]);

  // console.log(selectedCountry);
  useEffect(() => {
    getCountries();
    // DataCountry();
    if (selecteddate) {
      getTime();
    }
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selecteddate]);

  const confirmNote = (txt) => {
    setTxtNote(txt);
  };

  const onSubmit = (data) => {
    try {
      const whatsappMessage = generateWhatsAppMessage();

      axios
        .post(
          `${process.env.REACT_APP_API_URL}api/storeOrder`,
          {
            name: `${data.name}`,
            number: `${data.phoneNumber}`,
            email: `${data.email}`,
            address: `${area} - ${country} - ${data.street} - ${data.house} - ${data.block} - ${data.Avenue} - ${data.Apartment_no} - ${data.office_no} - ${data.building} - ${data.floor}`,
            price: productsInState.totalAmount + 2.5,
            products: productsInState.cartItems,

            dates: [dateFormated, dateFormated],
            appointment_ids: [appointment_id, appointment_id],

            special_request: `${
              txtNote !== undefined ? txtNote : "no special request"
            }`,

            country_id: selectedCountry,
            area_id: selectedAreas,
            device: "mobile",
            ip_address: "192.168.0.1",
            from_time_delivery: `${
              selectedTimeStart ? selectedTimeStart : "notSelected"
            }`,
            to_time_delivery: `${
              selectedTimeEnd ? selectedTimeEnd : "notSelected"
            }`,
          },
          {
            headers: { "content-Type": "Application/json" },
          }
        )
        .then((orderResponse) => {
          toast.success(
            orderResponse.data.message || "Order placed successfully"
          );
          window.open(
            `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`,
            "_blank"
          );
        })
        .catch((error) => {
          console.error("Order submission error:", error);
          toast.error("Failed to place the order.");
        });
    } catch (err) {
      toast.error(err.message);
    }
  };

  const formatAddressForWhatsApp = () => {
    const formData = getValues();
    let addressParts = [];

    // Directly add the value without labels
    if (country) addressParts.push(country);
    if (area) addressParts.push(area);
    if (formData.block) addressParts.push(formData.block);
    if (formData.street) addressParts.push(formData.street);

    switch (tab) {
      case "apartment":
        if (formData.building) addressParts.push(formData.building);
        if (formData.floor) addressParts.push(`الدور ${formData.floor}`);
        if (formData.Apartment_no)
          addressParts.push(`رقم الشقة ${formData.Apartment_no}`);
        break;
      case "office":
        if (formData.building) addressParts.push(formData.building);
        if (formData.floor) addressParts.push(`الدور ${formData.floor}`);
        if (formData.office_no)
          addressParts.push(`رقم المكتب ${formData.office_no}`);
        break;
      default: // Handles the "house" case as the default
        if (formData.house) addressParts.push(formData.house);
        break;
    }

    if (formData.avenue) addressParts.push(formData.avenue);

    // Concatenates the address parts with " - ", ensuring a clean, readable format
    return addressParts.join(" - ");
  };

  const generateWhatsAppMessage = (
    addressString = formatAddressForWhatsApp()
  ) => {
    const language = lang; // Assuming 'lang' is the state/context keeping track of the current language

    // Basic order details
    let message = language === "ar" ? `*طلبي:*\n` : `*My Order:*\n`;

    // Order items
    let imageUrlOfLastItem = "";
    productsInState.cartItems.forEach((item, index) => {
      imageUrlOfLastItem = item.image?.[0]?.url || "";
      message +=
        language === "ar"
          ? `${index + 1}- ${item.name}, الكمية: ${item.quantity}, السعر: ${
              item.price * item.quantity
            } د.ك\n`
          : `${index + 1}- ${item.name}, Qty: ${item.quantity}, Price: ${
              item.price * item.quantity
            } KWD\n`;
    });
    // Order time
    const currentDate = new Date();
    const locale = language === "ar" ? "ar-KW" : "en-KW";

    const options = {
      weekday: "long",
      month: "long",
      day: "numeric",
      timeZone: "Asia/Kuwait",
    };
    const timeOptions = {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "Asia/Kuwait",
    };
    const formattedDate = currentDate.toLocaleDateString(locale, options);
    const formattedTime = currentDate.toLocaleTimeString(locale, timeOptions);

    message += `\n${
      language === "ar" ? "وقت الطلب:" : "Order Time:"
    } ${formattedDate} ${formattedTime}`;

    message += `\n${language === "ar" ? `العنوان: ${addressString}` : `Address:${addressString}`} \n`;

    // Free space for URL if productsInState count is 1
    if (productsInState.cartItems.length === 1) {
      message += `\n${process.env.REACT_APP_API_URL}${imageUrlOfLastItem}\n`;
    }
    const fees = CartSection.fees || 2.5; // Set fees to 2.5 if undefined

    // Total amount
    message +=
      language === "ar"
        ? `الإجمالي مع التوصيل: ${productsInState.totalAmount + fees} د.ك.\n`
        : `Total with delivery: ${productsInState.totalAmount + fees} KWD.\n`;

    // Confirmation request
    message +=
      language === "ar"
        ? `يرجى تأكيد طلبي. شكرًا لك!`
        : `Please confirm my order. Thank you!`;

    return encodeURI(message);
  };

  const handleTermsChange = () => {
    setTermsAccepted(!termsAccepted);
  };

  if (location.pathname === "/store") {
    // If the current location is '/store', set the link to '/'
    backLink = "/";
  } else {
    // If the current location is '/category', set the link to '/store'
    backLink = "/store";
  }
  const handletimechange = (a) => {
    // console.log(a);
    setSelectedTimeStart(a);
    setSelectedTimeEnd(a);
    // setappointment_id(a);
  };

  //

  const generateOptions = (start, end) => {
    const options = [];
    for (let i = start; i <= end; i++) {
      options.push(i.toString().padStart(2, "0"));
    }
    return options;
  };

  const hours = generateOptions(1, 12);
  const minutes = generateOptions(0, 59);
  const ampmOptions = ["AM", "PM"];

  const onChangeNow = (newTime) => {
    setValueNow(newTime);
  };
  const handleHourChange = (e) => {
    const newHour = e.target.value;
    const newTime = `${newHour}:${valueNow.split(":")[1]}`;
    onChangeNow(newTime);
  };

  const handleMinuteChange = (e) => {
    const newMinute = e.target.value;
    const newTime = `${valueNow.split(":")[0]}:${newMinute}`;
    onChangeNow(newTime);
  };
  const handleAmPmChange = (e) => {
    const newAmPm = e.target.value;
    const newTime = `${valueNow.split(":")[0]}:${
      valueNow.split(":")[1]
    }:${newAmPm}`;
    onChangeNow(newTime);
  };

  const formatImageUrl = (imageUrl) => {
    const baseUrl = process.env.REACT_APP_API_URL;
    if (!imageUrl) return "";
    // Check if the imageUrl already includes the baseUrl
    if (imageUrl.startsWith(baseUrl)) {
      return imageUrl;
    }
    // Check if imageUrl starts with "http" which means it's a complete URL
    if (imageUrl.startsWith("http")) {
      return imageUrl;
    }
    // Otherwise, concatenate the baseUrl and the imageUrl
    return `${baseUrl}${imageUrl}`;
  };

  return (
    <section className="cartSection">
      <Helmet title="cart" />
      <div className="cartHeader">
        <div className={`container ${lang === "ar" ? "containerRe_ar" : ""}`}>
          <Link to={"/store"}>
            <img src={commonImg} alt="homeImg" />
            <h1>sweet_a2z company</h1>
          </Link>
          <div className="rightSideH">
            <Link to={backLink} className="searchIconH">
              <i className="ri-arrow-left-line"></i>
            </Link>

            <OverlayTrigger
              trigger="click"
              rootClose
              placement={"bottom"}
              style={{ height: "1000px" }}
              overlay={
                <Popover id={`popover-positioned-bottom`}>
                  <Popover.Body
                    className={`pop ${lang === "ar" ? "popCart" : ""}`}
                  >
                    {productsInState.cartItems.length > 0 ? (
                      <>
                        <div className="PopCards">
                          {productsInState.cartItems.map((item) => (
                            <div className="PopCardsCard" key={item.id}>
                              <div className="PopCardsImg">
                                <img
                                  src={formatImageUrl(
                                    item.imageUrl || item.image?.[0]?.url || ""
                                  )}
                                  alt="imgProduct"
                                />
                              </div>
                              <div className="PopCardsdetails">
                                <h4>{item.name}</h4>
                                <div className="quantityprice">
                                  {item.quantity} x {item.price} KWD
                                </div>
                              </div>
                              <div
                                className="btnTrash"
                                onClick={() =>
                                  dispatch(cartActions.deleteItem(item.id))
                                }
                              >
                                {" "}
                                <svg
                                  className="h-5 w-5  ltr:mr-1 rtl:ml-1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="17.107"
                                  height="19.687"
                                  viewBox="0 0 17.107 19.687"
                                >
                                  <g
                                    id="Group_9777"
                                    data-name="Group 9777"
                                    transform="translate(-3708.868 -2157.542)"
                                  >
                                    <g
                                      id="Group_650"
                                      data-name="Group 650"
                                      transform="translate(3708.868 2157.542)"
                                    >
                                      <path
                                        id="Path_331"
                                        data-name="Path 331"
                                        d="M15.7,36.122V49.807a2.945,2.945,0,0,1-2.973,2.917H4.319A2.9,2.9,0,0,1,1.4,49.807V36.122H.561A.562.562,0,0,1,0,35.561.53.53,0,0,1,.561,35H16.546a.562.562,0,0,1,.561.561.553.553,0,0,1-.561.5Zm-13.181,0V49.807A1.807,1.807,0,0,0,4.319,51.6h8.413a1.82,1.82,0,0,0,1.851-1.795V36.122Z"
                                        transform="translate(0 -33.037)"
                                        fill="#f40000"
                                      ></path>
                                      <path
                                        id="Path_332"
                                        data-name="Path 332"
                                        d="M90,105.561a.562.562,0,0,1,.561-.561.53.53,0,0,1,.561.561v8.75a.53.53,0,0,1-.561.561.562.562,0,0,1-.561-.561Z"
                                        transform="translate(-84.952 -99.111)"
                                        fill="#f40000"
                                      ></path>
                                      <path
                                        id="Path_333"
                                        data-name="Path 333"
                                        d="M195,105.561a.53.53,0,0,1,.561-.561.562.562,0,0,1,.561.561v8.75a.562.562,0,0,1-.561.561.53.53,0,0,1-.561-.561Z"
                                        transform="translate(-184.063 -99.111)"
                                        fill="#f40000"
                                      ></path>
                                      <path
                                        id="Path_334"
                                        data-name="Path 334"
                                        d="M142,105.561a.562.562,0,0,1,.561-.561.53.53,0,0,1,.561.561v8.75a.53.53,0,0,1-.561.561.562.562,0,0,1-.561-.561Z"
                                        transform="translate(-134.036 -99.111)"
                                        fill="#f40000"
                                      ></path>
                                      <path
                                        id="Path_335"
                                        data-name="Path 335"
                                        d="M108.561,1.122a.561.561,0,1,1,0-1.122h3.814a.53.53,0,0,1,.561.561.53.53,0,0,1-.561.561Z"
                                        transform="translate(-101.943)"
                                        fill="#f40000"
                                      ></path>
                                    </g>
                                  </g>
                                </svg>
                              </div>
                            </div>
                          ))}
                          <div
                            className={`subTotal ${
                              lang === "ar" ? "header_row_ar" : ""
                            }`}
                          >
                            <span>{t("subTotal")}</span>
                            <span>{productsInState.totalAmount}</span>
                          </div>
                        </div>
                        <div className="buttons">
                          <Link to={"/store/cart"} className="viewCartBtn">
                            {t("buttonReaview")}
                          </Link>
                          <button
                            className="viewCartBtn"
                            onClick={() => dispatch(cartActions.clearCart())}
                          >
                            {t("buttonEmpty")}
                          </button>
                        </div>
                      </>
                    ) : (
                      <h4>Your cart is empty!</h4>
                    )}
                  </Popover.Body>
                </Popover>
              }
            >
              <div className="header_logo search">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19.691"
                  height="25"
                  viewBox="0 0 19.691 25"
                  className="fill-white"
                >
                  <path
                    id="Path_8965"
                    data-name="Path 8965"
                    d="M32.526,10.38H29.137V9.621a5.667,5.667,0,1,0-11.334,0v.759H14.413a.8.8,0,0,0-.813.813V26.812A2.089,2.089,0,0,0,15.688,28.9H31.2a2.089,2.089,0,0,0,2.088-2.088V11.167A.733.733,0,0,0,32.526,10.38Zm-13.1-.786a4.04,4.04,0,1,1,8.08,0v.759H19.43Zm11.8,17.679H15.715a.486.486,0,0,1-.488-.488V11.98H31.713v14.8A.486.486,0,0,1,31.225,27.273Z"
                    transform="translate(-13.6 -3.9)"
                  ></path>
                </svg>
                <span className="numCart">{productsInState.totalQuantity}</span>
              </div>
            </OverlayTrigger>

            <div
              className={`lng ${lang === "ar" ? "d-none" : ""}`}
              onClick={() => {
                changeLanguage("ar");
                setLang("ar");
              }}
            >
              {lang === "en" ? "ع" : "ENG"}
            </div>
            <div
              className={`lng ${lang === "en" ? "d-none" : ""}`}
              onClick={() => {
                changeLanguage("en");
                setLang("en");
              }}
            >
              {lang === "en" ? "ع" : "ENG"}
            </div>
          </div>
        </div>
      </div>
      <div className="cartSectionBody">
        <div className="container">
          <div className={`row ${lang === "ar" ? "rwCart" : ""}`}>
            <div className="col-lg-8">
              <div
                className={`checkoutcontainer ${
                  lang === "ar" ? "checkoutcontainer_ar" : ""
                }`}
              >
                <div className="delivery">
                  <h2 className=" pb-3">{t("deliveryTitle")}</h2>
                  <div className="deliverySelectTime">
                    {/* <h4>{t('deliveryTime')}</h4> */}
                    {/* <Button
                      className="modalDateBtn"
                      onClick={() => setModalShow(true)}
                    >
                      {t('deliveryTimeSelect')}
                    </Button> */}
                    <div
                      className={`selecNow mb-3 ${
                        !selecNowActive ? "d-block" : ""
                      }`}
                    >
                      <Form.Check
                        // onClick={() => setModalShow(true)}
                        type={"radio"}
                        label={`${t("now")}`}
                        // defaultChecked
                        name="deliveryTime"
                        id={`disabled-default-radio`}
                        style={{ cursor: "pointer" }}
                        onClick={() => setselecNowActive(true)}
                      />
                      <div
                        className={`selectTime ${
                          !selecNowActive ? "d-none" : ""
                        }`}
                      >
                        <div className="timesToSelect">
                          <select
                            defaultValue={valueNow.split(":")[0]}
                            onChange={handleHourChange}
                          >
                            {hours.map((hour) => (
                              <option key={hour} value={hour}>
                                {hour}
                              </option>
                            ))}
                          </select>
                          <select
                            defaultValue={valueNow.split(":")[1]}
                            onChange={handleMinuteChange}
                          >
                            {minutes.map((minute) => (
                              <option key={minute} value={minute}>
                                {minute}
                              </option>
                            ))}
                          </select>
                          <select
                            defaultValue={valueNow.split(":")[2] || "AM"}
                            onChange={handleAmPmChange}
                          >
                            {ampmOptions.map((ampm) => (
                              <option key={ampm} value={ampm}>
                                {ampm}
                              </option>
                            ))}
                          </select>
                          <button
                            className="modalDateBtn btn btn-primary"
                            onClick={() => {
                              setSelectedTimeStart(valueNow);
                              setselecNowActive(false);
                            }}
                          >
                            {t("Submit")}
                          </button>
                        </div>
                      </div>
                    </div>
                    <Form.Check
                      onClick={() => {
                        setModalShow(true);
                        setselecNowActive(false);
                      }}
                      type={"radio"}
                      label={`${t("deliveryTimeSelect")}`}
                      id={`disabled-default-radio2`}
                      style={{ cursor: "pointer" }}
                      name="deliveryTime"
                    />

                    <MyVerticallyCenteredModal
                      show={modalShow}
                      onHide={handleclosemodal}
                      selecteddate={selecteddate}
                      handledatechange={handledatechange}
                      handletimechange={handletimechange}
                      data={dataTime}
                    />

                    <div className="timeSelected mt-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 23.141 23.141"
                      >
                        <g
                          id="Group_8865"
                          data-name="Group 8865"
                          transform="translate(-6972 -2407.93)"
                        >
                          <circle
                            id="Ellipse_57"
                            data-name="Ellipse 57"
                            cx="1"
                            cy="1"
                            r="1"
                            transform="translate(6988 2415.93)"
                          ></circle>
                          <path
                            id="Path_391"
                            data-name="Path 391"
                            d="M19.525,1.808H18.35V.9a.9.9,0,0,0-1.808,0v.9H12.429V.9a.9.9,0,0,0-1.808,0v.9H6.553V.9A.9.9,0,0,0,4.746.9v.9H3.616A3.62,3.62,0,0,0,0,5.424v14.1a3.62,3.62,0,0,0,3.616,3.616h6.915a.9.9,0,0,0,0-1.808H3.616a1.81,1.81,0,0,1-1.808-1.808V5.424A1.81,1.81,0,0,1,3.616,3.616h1.13v.9a.9.9,0,0,0,1.808,0v-.9h4.068v.9a.9.9,0,1,0,1.808,0v-.9h4.113v.9a.9.9,0,0,0,1.808,0v-.9h1.175a1.81,1.81,0,0,1,1.808,1.808v5.152a.9.9,0,0,0,1.808,0V5.424A3.62,3.62,0,0,0,19.525,1.808Z"
                            transform="translate(6972 2407.93)"
                          ></path>
                          <path
                            id="Path_392"
                            data-name="Path 392"
                            d="M275.469,270a5.469,5.469,0,1,0,5.469,5.469A5.475,5.475,0,0,0,275.469,270Zm0,9.13a3.661,3.661,0,1,1,3.661-3.661A3.665,3.665,0,0,1,275.469,279.13Z"
                            transform="translate(6714.203 2150.133)"
                          ></path>
                          <path
                            id="Path_393"
                            data-name="Path 393"
                            d="M373.215,331.853h-.407V330.9a.9.9,0,0,0-1.808,0v1.853a.9.9,0,0,0,.9.9h1.311a.9.9,0,0,0,0-1.808Z"
                            transform="translate(6617.768 2092.844)"
                          ></path>
                          <circle
                            id="Ellipse_58"
                            data-name="Ellipse 58"
                            cx="1"
                            cy="1"
                            r="1"
                            transform="translate(6984 2415.93)"
                          ></circle>
                          <circle
                            id="Ellipse_59"
                            data-name="Ellipse 59"
                            cx="1"
                            cy="1"
                            r="1"
                            transform="translate(6981 2419.93)"
                          ></circle>
                          <circle
                            id="Ellipse_60"
                            data-name="Ellipse 60"
                            cx="1"
                            cy="1"
                            r="1"
                            transform="translate(6977 2415.93)"
                          ></circle>
                          <circle
                            id="Ellipse_61"
                            data-name="Ellipse 61"
                            cx="1"
                            cy="1"
                            r="1"
                            transform="translate(6977 2419.93)"
                          ></circle>
                          <circle
                            id="Ellipse_62"
                            data-name="Ellipse 62"
                            cx="1"
                            cy="1"
                            r="1"
                            transform="translate(6977 2423.93)"
                          ></circle>
                          <circle
                            id="Ellipse_63"
                            data-name="Ellipse 63"
                            cx="1"
                            cy="1"
                            r="1"
                            transform="translate(6981 2423.93)"
                          ></circle>
                          <circle
                            id="Ellipse_64"
                            data-name="Ellipse 64"
                            cx="1"
                            cy="1"
                            r="1"
                            transform="translate(6981 2415.93)"
                          ></circle>
                        </g>
                      </svg>
                      {dateFormated}
                    </div>
                    <div className="timeSelected mt-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                      >
                        <g
                          id="Group_559"
                          data-name="Group 559"
                          transform="translate(-4120.006 6055.032)"
                        >
                          <path
                            id="Path_309"
                            data-name="Path 309"
                            d="M4125.929-6035.076c-.371-.212-.754-.4-1.113-.638a10.472,10.472,0,0,1-3.894-4.542,10.405,10.405,0,0,1-.816-2.859,10.126,10.126,0,0,1-.038-2.526,10.361,10.361,0,0,1,2.2-5.387,10.431,10.431,0,0,1,4.083-3.138c.033-.015.065-.033.1-.049a9.677,9.677,0,0,1,1.17-.4c.065-.017.13-.038.195-.057.439-.113.885-.193,1.332-.265.229-.01.457-.04.686-.055.173-.012.344-.011.517-.016a.411.411,0,0,0,.158-.022c.454.029.909.04,1.362.093.171.03.342.059.513.092.265.052.529.107.794.161a13.969,13.969,0,0,1,1.389.474c.363.177.737.333,1.09.534a10.533,10.533,0,0,1,3.419,3.086c.152.214.295.436.441.653l.444.817a5.546,5.546,0,0,0,.243.546c.173.437.322.882.457,1.332.041.185.085.368.121.554.051.27.1.54.143.81.031.253.05.508.066.763a10.754,10.754,0,0,1-.042,1.729,11.191,11.191,0,0,1-.286,1.563c-.092.28-.185.56-.274.84-.054.166-.138.32-.177.49l-.227.506-.463.86a15.281,15.281,0,0,1-.912,1.287,13.388,13.388,0,0,1-1.11,1.142,10.468,10.468,0,0,1-3,1.875c-.422.172-.855.31-1.29.446a13.223,13.223,0,0,1-1.337.253,9.914,9.914,0,0,1-1.361.095c-.455-.019-.909-.037-1.361-.1a7.351,7.351,0,0,1-1.3-.251.488.488,0,0,0-.061-.008c-.454-.133-.9-.291-1.338-.46Zm.517-1.28a7.012,7.012,0,0,0,1.361.546,8.791,8.791,0,0,0,2.14.394,9.117,9.117,0,0,0,3.457-.451,8.7,8.7,0,0,0,2.529-1.319l.707-.579a.518.518,0,0,0,.049-.034,9.368,9.368,0,0,0,1.12-1.241,8.86,8.86,0,0,0,1.427-2.783c.034-.114.073-.227.1-.342a6.626,6.626,0,0,0,.207-1.023,6.54,6.54,0,0,0,.1-1.335,6.17,6.17,0,0,0-.1-1.36,7.735,7.735,0,0,0-.3-1.361,8.677,8.677,0,0,0-.76-1.75c-.192-.334-.4-.656-.626-.971a4.992,4.992,0,0,0-.559-.674,9.261,9.261,0,0,0-.663-.665,5.07,5.07,0,0,0-.7-.568,7.742,7.742,0,0,0-1.535-.92,9.351,9.351,0,0,0-1.481-.549,7.912,7.912,0,0,0-1.492-.265c-.122-.009-.245,0-.364-.023a3.253,3.253,0,0,0-.551-.033,9.151,9.151,0,0,0-1.8.174,9.005,9.005,0,0,0-2.14.714,8.733,8.733,0,0,0-1.486.9,4.99,4.99,0,0,0-.7.576,5.469,5.469,0,0,0-.689.693,5.619,5.619,0,0,0-.522.637,7,7,0,0,0-.678,1.04,8.33,8.33,0,0,0-.71,1.687c-.027.086-.058.17-.082.257a6.565,6.565,0,0,0-.233,1.106,6.608,6.608,0,0,0-.1,1.36,6.1,6.1,0,0,0,.1,1.336,7.543,7.543,0,0,0,.3,1.361,7.982,7.982,0,0,0,.553,1.364l.027.048a6.887,6.887,0,0,0,.825,1.333,4.943,4.943,0,0,0,.509.623,6.882,6.882,0,0,0,.677.689,6.954,6.954,0,0,0,.721.586,6.89,6.89,0,0,0,1.311.8Z"
                          ></path>
                          <path
                            id="Path_310"
                            data-name="Path 310"
                            d="M4512.316-5890.612a2.606,2.606,0,0,1,.392.017.523.523,0,0,1,.415.578c0,.143,0,.287.007.429q-.015.668,0,1.335-.018.693,0,1.386-.017.667,0,1.335-.017.68,0,1.361c.009.1-.059.216.045.3.156.119.318.229.478.342q.508.39,1.036.754l.324.241c.367.271.733.545,1.1.812a.654.654,0,0,1,.178.253.577.577,0,0,1-.126.508c-.115.15-.219.31-.344.452a.488.488,0,0,1-.639.087c-.283-.187-.556-.388-.832-.584-.214-.152-.431-.3-.636-.463-.356-.285-.733-.541-1.1-.813-.281-.209-.562-.417-.85-.617a.578.578,0,0,1-.26-.514q0-2.4,0-4.81c0-.6,0-1.2,0-1.805a.513.513,0,0,1,.413-.563A3.025,3.025,0,0,1,4512.316-5890.612Z"
                            transform="translate(-381.807 -160.353)"
                          ></path>
                        </g>
                      </svg>
                      {selectedTimeStart
                        ? selectedTimeStart
                        : t("notimeselected")}
                    </div>
                  </div>
                </div>
                <div className="deliveryDetails">
                  <div className="formDeliveryHeader">
                    <h4>{t("deliveryFormTitle")}</h4>
                    <Link to={"/store/login"}>
                      <i className="ri-user-line"></i> <span>{t("Login")}</span>
                    </Link>
                  </div>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col className="my-3 col-lg-6">
                        <Form.Group controlId="formPhoneNumber">
                          <div
                            className={`input-with-label input-with-label-ar`}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <img
                              src={iconPhone}
                              alt="kuwaitIcon"
                              style={{
                                marginRight: "5px",
                                width: "30px",
                                height: "30px",
                              }}
                            />
                            <Form.Control
                              type="tel"
                              className="namee"
                              onChange={handlePhoneChange}
                              placeholder=""
                              {...register("phoneNumber", {
                                required: `${t("Mobilenumberisrequired")}`,
                              })}
                            />
                            <Form.Label>
                              {t("enterNumber")}
                              <span className="text-danger">*</span>
                            </Form.Label>
                          </div>
                          {errors.phoneNumber && (
                            <Form.Text className="text-danger">
                              {errors.phoneNumber.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="my-3">
                        <Form.Group controlId="formEmail">
                          <Form.Control
                            type="email"
                            placeholder={t("Email")}
                            {...register("email")}
                          />
                          {}
                        </Form.Group>
                      </Col>
                      {}
                      <Col className="my-3">
                        <Form.Group controlId="formName">
                          <div className="input-with-label">
                            <Form.Control
                              type="text"
                              className="namee"
                              placeholder={t("NameHolder")}
                              {...register("name", {
                                required: `${t("nameisrequired")}`,
                              })}
                            />
                            <Form.Label>
                              {t("NameHolder")}
                              <span className="text-danger">*</span>
                            </Form.Label>
                          </div>
                          <Form.Text className="text-danger">
                            {errors.name && errors.name.message}
                          </Form.Text>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col
                        className={`my-3 ${!selectedCountry ? "d-none" : ""}`}
                      >
                        <Form.Group controlId="formCity">
                          {}

                          <Form.Control
                            as="select" // Specify that this is a select input
                            className="namee selectCountry"
                            {...register("area", {
                              required: `${t("areaisrequired")}`,
                            })}
                            onChange={(e) => {
                              setSelectedAreas(e.target.value);
                              setArea(
                                areas &&
                                  countries &&
                                  areas?.data?.find(
                                    (it) => +it.id === +e.target.value
                                  ).name
                              );
                            }}
                          >
                            <option value="">{t("areaisrequired")}</option>
                            {countries &&
                              areas &&
                              areas?.data?.map((opt) => (
                                <option value={opt.id} key={opt.id}>
                                  {opt.name}
                                </option>
                              ))}
                          </Form.Control>

                          <Form.Text className="text-danger">
                            {errors.area && errors.area.message}
                          </Form.Text>
                        </Form.Group>
                      </Col>

                      <Col className="my-3">
                        <Form.Group controlId="formCountry">
                          {/* <div className="input-with-label"> */}

                          <Form.Control
                            as="select" // Specify that this is a select input
                            // className='namee'
                            className="namee selectCountry"
                            {...register("country", {
                              required: t("Countryisrequired"),
                            })}
                            onChange={(e) => {
                              setSelectedCountry(e.target.value);
                              setCoutry(
                                countries &&
                                  countries?.data?.find(
                                    (it) => +it.id === +e.target.value
                                  ).name
                              );
                            }}
                          >
                            <option value="">{t("Countryisrequired")}</option>
                            {countries &&
                              countries?.data?.map((opt) => (
                                <option
                                  value={opt.id}
                                  key={opt.id}
                                  onClick={() => setCoutry(opt.name)}
                                >
                                  {opt.name}
                                </option>
                              ))}
                            {/* Add more options as needed */}
                          </Form.Control>
                          {/* <Form.Label>{t('Countryisrequired')}<span className='text-danger'>*</span></Form.Label> */}
                          {/* </div> */}
                          <Form.Text className="text-danger">
                            {errors.country && errors.country.message}
                          </Form.Text>
                        </Form.Group>
                      </Col>
                    </Row>

                    <div className="selectPlaceType">
                      <div
                        onClick={() => setTab("house")}
                        className={`${
                          tab === "house" ? "House House_active" : "House"
                        }`}
                      >
                        <div className="House_title">
                          <i className="ri-home-8-line"></i>
                          {t("house")}
                        </div>
                      </div>
                      <div
                        onClick={() => setTab("apartment")}
                        className={`${
                          tab === "apartment" ? "House House_active" : "House"
                        }`}
                      >
                        <div className="House_title">
                          <i className="ri-building-4-line"></i>
                          {t("apartment")}
                        </div>
                      </div>
                      <div
                        onClick={() => setTab("office")}
                        className={`${
                          tab === "office" ? "House House_active" : "House"
                        }`}
                      >
                        <div className="House_title">
                          <i className="ri-hotel-line"></i>
                          {t("office")}
                        </div>
                      </div>
                    </div>
                    {tab === "house" ? (
                      <>
                        <Row>
                          <Col className="my-3">
                            <Form.Group controlId="block">
                              <div className="input-with-label">
                                <Form.Control
                                  type="text"
                                  placeholder={t("BlockHolder")}
                                  {...register("block", {
                                    required: "block is required",
                                  })}
                                />
                                <Form.Label>
                                  {t("BlockHolder")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                              </div>
                              <Form.Text className="text-danger">
                                {errors.block && errors.block.message}
                              </Form.Text>
                            </Form.Group>
                          </Col>

                          <Col className="my-3">
                            <Form.Group controlId="street">
                              <div className="input-with-label">
                                <Form.Control
                                  type="text"
                                  placeholder={t("streetHolder")}
                                  {...register("street", {
                                    required: "street is required",
                                  })}
                                />
                                <Form.Label>
                                  {t("streetHolder")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                              </div>
                              <Form.Text className="text-danger">
                                {errors.street && errors.street.message}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="my-3">
                            <Form.Group controlId="house">
                              <div className="input-with-label">
                                <Form.Control
                                  type="text"
                                  placeholder={t("HouseHolder")}
                                  {...register("house", {
                                    required: "house is required",
                                  })}
                                />
                                <Form.Label>
                                  {t("HouseHolder")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                              </div>
                              <Form.Text className="text-danger">
                                {errors.house && errors.house.message}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col className="my-3">
                            <Form.Group controlId="avenue">
                              <Form.Control
                                type="text"
                                placeholder={t("AvenueHolder")}
                                {...register("avenue")}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    ) : tab === "apartment" ? (
                      <>
                        <Row>
                          <Col className="my-3">
                            <Form.Group controlId="block">
                              <div className="input-with-label">
                                <Form.Control
                                  type="text"
                                  placeholder={t("BlockHolder")}
                                  {...register("block", {
                                    required: "block is required",
                                  })}
                                />
                                <Form.Label>
                                  {t("BlockHolder")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                              </div>
                              <Form.Text className="text-danger">
                                {errors.block && errors.block.message}
                              </Form.Text>
                            </Form.Group>
                          </Col>

                          <Col className="my-3">
                            <Form.Group controlId="street">
                              <div className="input-with-label">
                                <Form.Control
                                  type="text"
                                  placeholder={t("streetHolder")}
                                  {...register("street", {
                                    required: "street is required",
                                  })}
                                />
                                <Form.Label>
                                  {t("streetHolder")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                              </div>
                              <Form.Text className="text-danger">
                                {errors.street && errors.street.message}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="my-3">
                            <Form.Group controlId="building">
                              <Form.Control
                                type="text"
                                placeholder={t("buildingHolder")}
                                {...register("building", {
                                  required: "building is required",
                                })}
                              />
                              <Form.Text className="text-danger">
                                {errors.building && errors.building.message}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col className="my-3">
                            <Form.Group controlId="floor">
                              <Form.Control
                                type="text"
                                placeholder={t("FloorHolder")}
                                {...register("floor", {
                                  required: "floor is required",
                                })}
                              />
                              <Form.Text className="text-danger">
                                {errors.floor && errors.floor.message}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="my-3">
                            <Form.Group controlId="Apartment_no">
                              <Form.Control
                                type="text"
                                placeholder={t("ApartmentNoHolder")}
                                {...register("Apartment_no", {
                                  required: "Apartment_no is required",
                                })}
                              />
                              <Form.Text className="text-danger">
                                {errors.Apartment_no &&
                                  errors.Apartment_no.message}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col className="my-3">
                            <Form.Group controlId="avenue">
                              <Form.Control
                                type="text"
                                placeholder={t("AvenueHolder")}
                                {...register("avenue")}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    ) : tab === "office" ? (
                      <>
                        <Row>
                          <Col className="my-3">
                            <Form.Group controlId="block">
                              <div className="input-with-label">
                                <Form.Control
                                  type="text"
                                  placeholder={t("BlockHolder")}
                                  {...register("block", {
                                    required: "block is required",
                                  })}
                                />
                                <Form.Label>
                                  {t("BlockHolder")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                              </div>
                              <Form.Text className="text-danger">
                                {errors.block && errors.block.message}
                              </Form.Text>
                            </Form.Group>
                          </Col>

                          <Col className="my-3">
                            <Form.Group controlId="street">
                              <div className="input-with-label">
                                <Form.Control
                                  type="text"
                                  placeholder={t("streetHolder")}
                                  {...register("street", {
                                    required: "street is required",
                                  })}
                                />
                                <Form.Label>
                                  {t("streetHolder")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                              </div>
                              <Form.Text className="text-danger">
                                {errors.street && errors.street.message}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="my-3">
                            <Form.Group controlId="building">
                              <Form.Control
                                type="text"
                                placeholder={t("buildingHolder")}
                                {...register("building", {
                                  required: "building is required",
                                })}
                              />
                              <Form.Text className="text-danger">
                                {errors.building && errors.building.message}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col className="my-3">
                            <Form.Group controlId="floor">
                              <Form.Control
                                type="text"
                                placeholder={t("FloorHolder")}
                                {...register("floor", {
                                  required: "floor is required",
                                })}
                              />
                              <Form.Text className="text-danger">
                                {errors.floor && errors.floor.message}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="my-3">
                            <Form.Group controlId="office_no">
                              <Form.Control
                                type="text"
                                placeholder={t("OfficeNoHolder")}
                                {...register("office_no", {
                                  required: "office_no is required",
                                })}
                              />
                              <Form.Text className="text-danger">
                                {errors.office_no && errors.office_no.message}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col className="my-3">
                            <Form.Group controlId="avenue">
                              <Form.Control
                                type="text"
                                placeholder={t("AvenueHolder")}
                                {...register("avenue")}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                    <div className="specialRequest">
                      <div className="specialRequestQuestion">
                        <i className="ri-sticky-note-line"></i>
                        {t("specialRequest")}
                      </div>
                      <div
                        className="AddNote"
                        onClick={() => setModalShowNote(true)}
                      >
                        {t("addNote")}
                      </div>
                      <ModalNote
                        onHide={handleclosemodalNote}
                        show={modalShowNote}
                        confirmNote={confirmNote}
                      />
                    </div>

                    <Form.Group
                      controlId="termsCheckbox"
                      className="mb-2 checkCollapse"
                      onClick={handleTermsChange}
                    >
                      <Form.Check
                        className="checkForm"
                        type="checkbox"
                        label={`${t("terms")}`}
                        checked={termsAccepted}
                        onClick={handleTermsChange}
                        {...register("termsCheckbox", {
                          required: "termsCheckbox is required",
                        })}
                      />
                      <Form.Text className="required accept terms">
                        {errors.termsCheckbox && errors.termsCheckbox.message}
                      </Form.Text>
                      <Collapse in={termsAccepted} className="collapseChech">
                        <div>
                          <p>
                            {" "}
                            ١ - لايتم الغاء اي طلب في وقت خروجه للتوصيل
                            <br />
                            ٢ - الاوقات لدينا فترات زمنيه يتم التوصيل فيها لايتم
                            اختيار ساعه محدده ولايتم الاخذ بالاعتبار اي ملاحظه
                            لساعه معينه
                            <br />
                            ٣- لخدمتكم يرجى العلم بأن الفترات لدينا ملتزمين فيها
                            وبأعداد محدده وتقفل تلقائي لكل فتره في حال غلط
                            العميل بالفاتوره او بالتاريخ او بالفتره ( يتم تحديد
                            موعد جديد حسب مايتم بالاتفاق المتاح للعمل فيه مع
                            موظف خدمه العملاء )
                          </p>
                        </div>
                      </Collapse>
                    </Form.Group>

                    <Button className="modalDateBtn col-lg-12" type="submit">
                      {t("Submit")}
                    </Button>
                  </Form>

                  <a
                    href={`https://wa.me/${whatsappNumber}?text=${generateWhatsAppMessage()}`}
                    target="_blank"
                    className="buttonToCart contactWhats"
                    rel="noreferrer"
                  >
                    <i className="ri-whatsapp-line"></i>
                    <span>للطلب عبر الواتساب</span>
                  </a>
                </div>
                <div className="PayWith">
                  <h2 className="pt-4 pb-3">{t("PayWith")}</h2>
                  <div className="payWithContainer">
                    <div className="paiwithkinet">
                      <div className="knetIcon">
                        <img src={knetIcon} alt="kneticon" />
                        KNET
                      </div>
                      <div className="priceKnet">
                        {t("currency")} {productsInState.totalAmount + 2.5}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          stroke="currentColor"
                          aria-hidden="true"
                          className="w-4 h-4 md:w-5 md:h-5 inline translate rtl:rotate-180"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9 5l7 7-7 7"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <CartSection />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Cart;
